import React, { ReactNode } from 'react';
import { verticalListSortingStrategy, horizontalListSortingStrategy, rectSortingStrategy } from '@dnd-kit/sortable';
import { Sortable, Props as SortableProps } from './Sortable';
import { GridContainer, List } from './components';
import { MultipleContainers } from './MultipleContainers';

const baseStyles: React.CSSProperties = {
	height: 150,
	width: 150,
};

const verticalListProps: Partial<SortableProps> = {
	Container: (props: any) => <List {...props} />,
	strategy: verticalListSortingStrategy,
};

const horizontalListProps: Partial<SortableProps> = {
	Container: (props: any) => <List horizontal {...props} />,
	getItemStyles: () => baseStyles,
	strategy: horizontalListSortingStrategy,
};

const VerticalLayout = (itemCount: number) => {
	return <Sortable {...verticalListProps} itemCount={itemCount} />;
};

const HorizontalLayout = (itemCount: number) => {
	return <Sortable {...horizontalListProps} itemCount={itemCount} />;
};

const GridLayout = (itemCount: number, columns: number) => {
	return (
		<MultipleContainers
			columns={columns}
			itemCount={itemCount}
			strategy={rectSortingStrategy}
			wrapperStyle={() => ({
				width: 84,
				height: 84,
			})}
			minimal
			vertical
		/>
	);
};

const AppSwitcherLayout = (itemCount: number, items: any, children?: ReactNode[]) => {
	return (
		<MultipleContainers
			columns={4}
			itemCount={itemCount}
			strategy={rectSortingStrategy}
			children={children}
			items={items}
			wrapperStyle={() => ({
				width: 84,
				height: 84,
			})}
			minimal
			vertical
		/>
	);
};

const MultipleVerticalLayout = (itemCount: number) => {
	return <MultipleContainers itemCount={itemCount} />;
};

export const getDndTemplate = (props: any) => {
	const { itemCount, columns, items, children } = props;
	let dndStyle: any;

	switch (props.dndTemplate) {
		case 'Vertical':
			dndStyle = VerticalLayout(itemCount);
			break;

		case 'Horizontal':
			dndStyle = HorizontalLayout(itemCount);
			break;

		case 'Grid':
			dndStyle = GridLayout(itemCount, columns);
			break;

		case 'AppSwitcher':
			dndStyle = AppSwitcherLayout(itemCount, items);
			break;

		case 'MultipleVertical':
			dndStyle = MultipleVerticalLayout(itemCount);
			break;

		case 'Custom':
			dndStyle = AppSwitcherLayout(itemCount, items, children);
			break;

		default:
			dndStyle = {};
			break;
	}

	return dndStyle;
};
